module.exports = __webpack_public_path__ + "img/logo_flatprime.b8ff1393.svg";